var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ApiService = /** @class */ (function () {
    function ApiService(http) {
        this.http = http;
        this.BASE_URL = environment.api_url + '/api/';
        this.baseHeaders = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
    }
    ApiService.prototype.get = function (url, options) {
        if (options === void 0) { options = {}; }
        return this.http.get("" + this.BASE_URL + url, {
            headers: new HttpHeaders(__assign({}, this.baseHeaders, options.headers)),
            params: new HttpParams({ fromObject: options.query }),
        });
    };
    ApiService.prototype.post = function (url, data, options) {
        if (options === void 0) { options = {}; }
        return this.http.post("" + this.BASE_URL + url, data, {
            headers: new HttpHeaders(__assign({}, this.baseHeaders, options.headers)),
        });
    };
    ApiService.prototype.patch = function (url, data, options) {
        if (options === void 0) { options = {}; }
        return this.http.patch("" + this.BASE_URL + url, data, {
            headers: new HttpHeaders(__assign({}, this.baseHeaders, options.headers)),
        });
    };
    ApiService.prototype.delete = function (url, options) {
        if (options === void 0) { options = {}; }
        return this.http.delete("" + this.BASE_URL + url, {
            headers: new HttpHeaders(__assign({}, this.baseHeaders, options.headers)),
            params: new HttpParams({ fromObject: options.query }),
        });
    };
    ApiService.ngInjectableDef = i0.defineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.inject(i1.HttpClient)); }, token: ApiService, providedIn: "root" });
    return ApiService;
}());
export { ApiService };
